import React from 'react';
import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import constants from '@shared-styles/constants.module.scss';
import SkeletonWrapper from './skeleton/SkeletonWrapper';

/**
 * @typedef {object} MuiSwitchOwnProps
 * @property {boolean} [loading]
 */

/**
 * @typedef {MuiSwitchOwnProps & React.ComponentProps<typeof Switch>} MuiSwitchProps
 */

/**
 * @param {MuiSwitchProps} props
 */
const MuiSwitch = props => {
  const { loading = false, ...switchProps } = props;

  return (
    <SkeletonWrapper show={loading}>
      <StyledSwitch {...switchProps} />
    </SkeletonWrapper>
  );
};

const StyledSwitch = styled(Switch)(() => ({
  width: 72,
  height: 22,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(1px)',
    '&.Mui-checked': {
      transform: 'translateX(50px)'
    }
  },
  '& .MuiIconButton-root:hover': {
    background: 'transparent'
  },
  '& .MuiSwitch-switchBase:not(.MuiSwitch-switchBase.Mui-checked) + .MuiSwitch-track': {
    backgroundColor: constants.switchColorUnchecked,
    opacity: 1
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: constants.switchColorChecked,
    opacity: 1
  },
  '& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
    opacity: '0.7 !important'
  },
  '& .MuiSwitch-track': {
    borderRadius: 11
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
    color: 'white'
  }
}));

export default MuiSwitch;
